import React, { useEffect, useRef, useState } from 'react';
import './style.scss';
import { HoverText } from '../../shared/TextFx';
import { useModal } from '../../shared/ModalContext';
import logo from './../../assets/header-logo-blue.svg';

const NAV_ITEMS = [
  { label: 'About US', href: '#about' },
  { label: 'Services', href: '#services' }, 
  { label: 'Tracking', href: '#' },
  { label: 'Blogs', href: '#' },
  { label: 'Partner With Us', href: '#' },
];

const LANGUAGES = [
  { label: 'Eng', href: '/' },
  { label: 'Ukr', href: '/uk/main/' },
  { label: 'Pol', href: '/pl/main/' },
];

const Header = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [langOpen, setLangOpen] = useState(false);
  const [scrollHidden, setScrollHidden] = useState(false);
  const [scrolledPastHero, setScrolledPastHero] = useState(false);
  const { openModal } = useModal();

  const headerRef = useRef(null);
  const langWrapRef = useRef(null);
  const lastYRef = useRef(typeof window !== 'undefined' ? window.scrollY : 0);

  const closeDrawer = () => setDrawerOpen(false);
  const toggleDrawer = () => setDrawerOpen((prev) => !prev);
  const toggleLang = () => setLangOpen((prev) => !prev);

  /* hide on scroll down / show on scroll up, past a 160px threshold */
  useEffect(() => {
    function update() {
      const y = window.scrollY;
      setScrollHidden(y > 160 && y > lastYRef.current);
      lastYRef.current = y;
    }
    window.addEventListener('scroll', update, { passive: true });
    return () => window.removeEventListener('scroll', update);
  }, []);

  /* toggle .active once the page is scrolled past the hero section */
  useEffect(() => {
    const hero = document.querySelector('.hero');
    if (!hero) return undefined;

    function update() {
      const headerHeight = headerRef.current ? headerRef.current.offsetHeight : 0;
      setScrolledPastHero(window.scrollY > hero.offsetHeight - headerHeight);
    }

    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    return () => {
      window.removeEventListener('scroll', update);
      window.removeEventListener('resize', update);
    };
  }, []);

  /* mobile hamburger drawer: lock body scroll while the drawer is open */
  useEffect(() => {
    document.body.classList.toggle('overflow-hidden', drawerOpen);
  }, [drawerOpen]);

  /* language dropdown: close on outside click */
  useEffect(() => {
    if (!langOpen) return undefined;
    function handleOutsideClick(e) {
      if (langWrapRef.current && !langWrapRef.current.contains(e.target)) {
        setLangOpen(false);
      }
    }
    document.addEventListener('click', handleOutsideClick);
    return () => document.removeEventListener('click', handleOutsideClick);
  }, [langOpen]);

  return (
    <header
      className={`header${scrollHidden ? ' is-hidden' : ''}${scrolledPastHero ? ' active' : ''}`}
      ref={headerRef}
    >
      <div className={`container header__container ${drawerOpen ? 'active' : ''}`}>
        <a className="header__logo" href="/">
          <img alt="MVP" className="header__logo-img" src={logo} />
        </a>

        <nav className="header__menu">
          {NAV_ITEMS.map((item, index) => (
            <a className="header__menu-item text-hover" href={item.href} key={index} onClick={closeDrawer}>
              <HoverText words={item.label} darkSecond />
            </a>
          ))}
        </nav>

        <div className="header__actions">
          <button
            aria-label="Open hamburger menu"
            className={`header__hamburger-btn btn ${drawerOpen ? 'active' : ''}`}
            onClick={toggleDrawer}
            type="button"
          >
            <span className="is-not-active">Menu</span>
            <span className="is-active">Close</span>
          </button>

          <button aria-label="Open modal" className="header__btn text-hover btn" onClick={openModal} type="button">
            <span className="btn__inner">
              <HoverText words="Contact Us" darkSecond={false} />
            </span>
          </button>

          {/* <div className="header__lang dropdown" ref={langWrapRef}>
            <div className={`header__lang-heading btn ${langOpen ? 'active' : ''}`} onClick={toggleLang}>
              <span className="btn__inner">
                Eng
                <svg fill="none" height="12" viewBox="0 0 13 12" width="13" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M1.267 7.06149L5.84961 11.7365C6.19441 12.0878 6.80452 12.0878 7.15054 11.7365L11.7331 7.06149C12.0902 6.69643 12.0889 6.10663 11.7295 5.74406C11.37 5.38148 10.7905 5.38148 10.4322 5.74654L7.41586 8.82221V0.931267C7.41586 0.415966 7.00504 0 6.49885 0C5.99266 0 5.58184 0.415966 5.58184 0.931267V8.82221L2.56671 5.74654C2.38698 5.56401 2.15223 5.47337 1.91625 5.47337C1.68272 5.47337 1.44796 5.56401 1.26945 5.74406C0.911205 6.10663 0.909982 6.69643 1.267 7.06149Z"
                    fill="#002855"
                  />
                </svg>
              </span>
            </div>
            <div className={`header__lang-dropdown ${langOpen ? 'is-open' : 'hidden'}`}>
              <div className="header__lang-list">
                {LANGUAGES.map((lang, index) => (
                  <a className="header__lang-item text-hover" href={lang.href} key={index}>
                    <HoverText words={lang.label} />
                  </a>
                ))}
              </div>
            </div>
          </div> */}
        </div>
      </div>

      <div className={`header__hamburger container ${drawerOpen ? 'active' : ''}`} />
    </header>
  );
};

export default Header;